export default __webpack_public_path__ + "static/media/icon-coin-gfi.582d156b.svg";